import { Injectable } from "@angular/core";
import { AbstractControl, NgForm } from "@angular/forms";
import { MatDialog } from "@angular/material/dialog";
import { AlertDialogComponent } from "../components/alert-dialog/alert-dialog.component";
import { AlertDialogOptions } from "../components/alert-dialog/alert-dialog-options";

 @Injectable({ providedIn: 'root' })
export class FormValidationService {
  constructor(private dialog: MatDialog) {}

   public checkFormValidity(
     form: { valid: boolean } | null | undefined,
     options?: Partial<{ title: string; message: string; buttonText: string }>
   ): boolean
   {
     if (!form?.valid)
     {
       const dialogData = {
         title: options?.title ?? "Alert",
         message: options?.message ?? "Please fully fill out the form in order to continue.",
         buttonText: options?.buttonText ?? "Close",
       };

       setTimeout(() =>
       {
         this.dialog.open(AlertDialogComponent, {
           panelClass: "form-field-less-than-180",
           maxWidth: "600px",
           maxHeight: "500px",
           data: dialogData,
         });
       }, 150);

       return false;
     }

     return true;
   }

} 